import { useLocation } from 'react-router';
import TransactionDetails from './TransactionDetails';

const NewTransactionView = () => {
  const location = useLocation();
  const state = location?.state || {};
  const { transaction } = state;

  return <TransactionDetails _isNew transactionObject={transaction} />;
};

export default NewTransactionView;
